import paymentService from '@/services/payment.service'
import { createGenericStore } from './generic.store'

export const usePaymentStore = createGenericStore<Payment>(
  'payments',
  paymentService,
)
